// eslint-disable-next-line no-restricted-imports
import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Outlet, useSearchParams } from "react-router-dom";
import {
  setCurrentCompany,
  updateUser,
} from "../../store/reducers/currentUserSlice";
import errors from "../../services/errors";
import { AxiosContext } from "../../services/axios/AxiosContext";

/**
 * A wrapper around all embedded content that takes care of receiving the token info and setting up axios interceptors / current user data.
 */
function EmbedLayout({ currentUser }) {
  let searchParams = useSearchParams()[0];
  const [token] = useState(searchParams.get("token"));
  const [companyId] = useState(searchParams.get("company_id"));
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentCompany(companyId));
  }, [companyId, dispatch]);
  useEffect(() => {
    if (token) {
      // The following two lines are probably not needed anymore.
      axios.interceptors.request.clear(); // remove all other ones (for now, the one setup in AuthenticationManager)
      axios.interceptors.response.clear(); // just in case - don't want 401 handlers firing on this endpoint.
      const useGivenToken = axios.interceptors.request.use(
        async function (config) {
          config.headers.Authorization = token;
          try {
            const separator = (config.url || "").includes("?") ? "&" : "?";
            config.url = `${config.url || ""}${separator}embeddedLayout=1`;
          } catch (err) {
            // If even that fails, do nothing — preserve original config
          }
          return config;
        },
      );
      axios
        .get("/user/me")
        .then((res) =>
          dispatch(
            updateUser({
              ...res.data.user,
              is_impersonating: res.data.is_impersonating ?? false,
            }),
          ),
        )
        .catch((e) => {
          errors.report(e);
          setError(e);
        });
      return () => {
        axios.interceptors.request.eject(useGivenToken);
      };
    }
  }, [dispatch, token]);

  if (error) {
    return <p>Error: {error.message ?? "Unable to load content"}</p>;
  }
  if (token && currentUser?.uid && currentUser.currentCompanyId) {
    return (
      <AxiosContext.Provider value={axios}>
        <Outlet />
      </AxiosContext.Provider>
    );
  } else {
    return <p>Loading...</p>;
  }
}
const mapStateToProps = (state) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(EmbedLayout);
